import { PageButtonProps } from '#/common/components/SubPage';
import { PageDropDownButtonProps } from '#/common/components/SubPage/PageActions/PageDropDownButton';
import { CurrentUserData } from '#/graphql/types';
import { createContext } from 'react';

export type PageAction =
  // common options for all actions
  {
    id: string;
    alwaysShow?: boolean;
  } & (
    | {
        // props specific for given action type
        type: 'button';
        props: PageButtonProps;
      }
    | {
        type: 'dropdown-button';
        props: PageDropDownButtonProps;
      }
  );

export interface PageContextType extends Omit<Partial<CurrentUserData>, '__typename'> {
  actions: PageAction[];
  setActions: React.Dispatch<React.SetStateAction<PageAction[]>>;
}

const PageContext = createContext<PageContextType>({
  actions: [],
  setActions: () => {},
});

export default PageContext;
